export default __webpack_public_path__ + "static/media/locations.a00eec15.svg";